import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { buildApiUrl } from '../config/api.config';
import AIBackgroundEffects from './AIBackgroundEffects';
import NotificationToast from './NotificationToast';
import './ClientLogin.css';

const ClientLogin = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState(null);

  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCredentials(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!credentials.username || !credentials.password) {
      setNotification({ message: 'Por favor ingresa tu email/usuario y contraseña', type: 'error' });
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(
        buildApiUrl('/api/auth/login'),
        credentials
      );

      if (response.data.success) {
        // Guardar token y datos del usuario
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));

        setNotification({ message: 'Login exitoso', type: 'success' });

        // Redirigir según el rol
        if (response.data.user.role === 'cliente') {
          setTimeout(() => navigate('/client/dashboard'), 500);
        } else {
          // Si es admin, redirigir al panel de admin
          localStorage.setItem('adminToken', response.data.token);
          localStorage.setItem('adminInfo', JSON.stringify(response.data.user));
          setTimeout(() => navigate('/admin/dashboard'), 500);
        }
      }
    } catch (error) {
      console.error('Login error:', error);
      setNotification({
        message: error.response?.data?.message || 'Error al iniciar sesión. Por favor intenta de nuevo.',
        type: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="client-login-container">
      <AIBackgroundEffects step={1} />

      <div className="client-login-card">
        <div className="client-login-header">
          <h1>🤖 AI Voice Agent</h1>
          <h2>Bienvenido de vuelta</h2>
          <p>Accede a tu panel de control de agentes de voz</p>
        </div>

        <form onSubmit={handleSubmit} className="client-login-form">
          <div className="client-login-form-group">
            <label htmlFor="username">Email o Usuario</label>
            <input
              type="text"
              id="username"
              name="username"
              value={credentials.username}
              onChange={handleInputChange}
              placeholder="tu@email.com o tu_usuario"
              autoComplete="username"
              required
            />
          </div>

          <div className="client-login-form-group">
            <label htmlFor="password">Contraseña</label>
            <input
              type="password"
              id="password"
              name="password"
              value={credentials.password}
              onChange={handleInputChange}
              placeholder="Tu contraseña"
              autoComplete="current-password"
              required
            />
          </div>

          <button
            type="submit"
            className="client-login-button"
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="client-login-spinner"></span>
                Iniciando sesión...
              </>
            ) : (
              'Iniciar Sesión'
            )}
          </button>
        </form>

        <div className="client-login-links">
          <p className="client-login-register-link">
            ¿No tienes cuenta? <Link to="/register">Regístrate aquí</Link>
          </p>
          <p className="client-login-admin-link">
            ¿Eres administrador? <Link to="/admin/login">Panel de Admin</Link>
          </p>
        </div>

        <div className="client-login-footer">
          <p className="client-login-security-note">
            🔒 Conexión segura con encriptación SSL
          </p>
        </div>
      </div>

      {/* Notification Toast */}
      {notification && (
        <NotificationToast
          message={notification.message}
          type={notification.type}
          onClose={() => setNotification(null)}
        />
      )}
    </div>
  );
};

export default ClientLogin;
